// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar[data-v-0ef0d6d7] {\n  height: 100px;\n  background-color: #1a6a72;\n}", ""]);
// Exports
module.exports = exports;
